// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__XvQNy","sectionActive":"Section_sectionActive__jikO4","pageContainer":"Section_pageContainer__3VTcN","mainContent":"Section_mainContent__rDRa4"};